function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m58 28h-16v4h8v7h8v2h4v-9c0-2.209-1.791-4-4-4z",
  fill: "#f5ba5b"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m56 35h2v6h-2z",
  fill: "#f9d69d"
})), /*#__PURE__*/React.createElement("path", {
  d: "m50 39h8v19h-8z",
  fill: "#6ec1ed"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4 2h34v56h-34z",
  fill: "#999"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4 48.761c14.642-1.938 26-15.861 26-32.761 0-5.006-1.002-9.749-2.785-14h-23.215z",
  fill: "#adadad"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8 6h26v52h-26z",
  fill: "#bfbfbf"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8 47.914c12.659-3.711 22-16.589 22-31.914 0-3.489-.496-6.845-1.395-10h-20.605z",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m2 58h60v4h-60z",
  fill: "#999"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m53 42h2v16h-2z",
  fill: "#8bcdf1"
})), /*#__PURE__*/React.createElement("path", {
  d: "m55 26c-1.105 0-2-.895-2-2v-2c0-1.105.895-2 2-2 1.105 0 2 .895 2 2v2c0 1.105-.895 2-2 2z",
  fill: "#f9d6b5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23 40h22v18h-22z",
  fill: "#bf8859"
}), /*#__PURE__*/React.createElement("path", {
  d: "m27 54h14v4h-14z",
  fill: "#d5cec2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29 54v-1c0-2.761 2.239-5 5-5 2.761 0 5 2.239 5 5v1z",
  fill: "#e7e4dd"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m23 43h22v2h-22z",
  fill: "#cca07a"
})), /*#__PURE__*/React.createElement("path", {
  d: "m12 26h4v8h-4z",
  fill: "#fff"
}));

var SvgDoormat = function SvgDoormat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoormat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doormat.409404df.svg";
export { ForwardRef as ReactComponent };